var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.getId,"iframe-name":_vm.getIframeName,"src":_vm.getUrl,"mode":_vm.mode,"activity-id":_vm.activityId}})}
var staticRenderFns = []

export { render, staticRenderFns }